(function ($) { 
  // Function to copy textarea to checkboxes
  if ($('.technology-form textarea').length > 0) {
      $('.technology-form textarea').each(function(index) {
          var textareaLabel = $(this).attr('placeholder') || 'Textarea ' + (index + 1); // Use placeholder as label or default label
          var textareaId = 'textarea-' + index; // Assign unique ID to each textarea
          $(this).attr('id', textareaId); // Add the ID to the textarea itself

          var checkboxId = 'checkbox-' + index; // Unique checkbox ID
          // Create a checkbox element
          var checkbox = $('<input>', {
              type: 'checkbox',
              id: checkboxId,
              'data-textarea-id': textareaId // Store textarea ID in checkbox
          });
          // Create a label for the checkbox
          var label = $('<label>', {
              for: checkboxId,
              text: textareaLabel
          });
          // Create a div container for the checkbox and label
          var checkboxContainer = $('<div>', {
              class: 'checkbox-container' // Add a class for styling purposes
          });
          // Append checkbox and label to the container div
          checkboxContainer.append(checkbox).append(label);
          // Append the container div to the .technology-checkboxes div
          $('.technology-checkboxes').append(checkboxContainer);

          // Bind the checkbox to control the corresponding textarea
          checkbox.change(function() {
              var textareaId = $(this).data('textarea-id'); // Get the related textarea ID
              var textarea = $('#' + textareaId); // Find the corresponding textarea
              if ($(this).is(':checked')) {
                  textarea.val('true'); // Set the textarea value to 'true' when checked
              } else {
                  textarea.val(''); // Clear the value when unchecked
              }
          });
      });
  }

  // Function to equalize the height of .elementor-widget-wrap elements inside .compare-table-div
  function equalizeHeights() {
      if ($('.compare-table-div').length > 0 && $('body').hasClass('single-e-landing-page')) {
          $('.compare-table-div:visible').each(function() {
              var maxHeight = 0;

              // Znajdź najwyższy element w ramach .compare-table-div
              $(this).find('.elementor-widget-wrap').each(function() {
                  var thisHeight = $(this).outerHeight();
                  if (thisHeight > maxHeight) {
                      maxHeight = thisHeight;
                  }
              });

              // Ustaw maksymalną wysokość na wszystkie .elementor-widget-wrap w tym .compare-table-div
              $(this).find('.elementor-widget-wrap').css('height', maxHeight);
          });
      }
  }

  // Call the function on load
  equalizeHeights();

  // Call the function on window resize
  $(window).resize(function() {
      equalizeHeights();
  });

  $('.postid-17597 .owl-item, .postid-17597 .ue-carousel-item').on('click',function(){
    let link = $(this).find('a').eq(0).attr('href').replace('#','');
    $('.izodomvstradycja, .izodomvsdrewno, .izodomvsprefabrykat').hide();
    $('.' + link).show();
    equalizeHeights();
    return false;
  });
  
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/partials/technology-lp.js